import { useState } from "react";
import { useSelector } from "react-redux";
import editIcon from "../../../../images/icons/edit.svg";
import deleteIcon from "../../../../images/icons/delete.svg";
import { Badge } from "react-bootstrap";
import { Translate } from "../../../Enums/Tranlate";
import ConfirmModal from "../../../common/ConfirmModal";
import DeleteModal from "../../../common/DeleteModal";
import VendorProductsService from "../../../../services/VendorProductsService";

const CardItem = ({ item, setAddModal, index, setItem, setShouldUpdate }) => {
	const [deleteModal, setDeleteModal] = useState(false);
	const Auth = useSelector((state) => state.auth?.auth);
	const isExist = (data) => Auth?.roles?.includes(data);
	const lang = useSelector((state) => state.auth?.lang);
	const vendorProductsService = new VendorProductsService();

	return (
		<tr key={index} className="text-center">
			<td>{item[`name_${lang}`] || "-"}</td>
			<td>{item?.price || "-"}</td>
			<td>{item?.quantity || "-"}</td>
			<td>
				<div className="d-flex" style={{ gap: "20px" }}>
					<img
						src={editIcon}
						onClick={() => {
							setItem(item);
							setAddModal(true);
						}}
						className="cursor-pointer"
						alt="edit"
						width={24}
					/>
					<img
						src={deleteIcon}
						onClick={() => {
							setItem(item);
							setDeleteModal(true);
						}}
						className="cursor-pointer"
						alt="edit"
						width={24}
					/>
				</div>
			</td>
			{deleteModal && (
				<DeleteModal
					open={deleteModal}
					titleMsg={item[`name_${lang}`]}
					deletedItem={item}
					modelService={vendorProductsService}
					onCloseModal={setDeleteModal}
					setShouldUpdate={setShouldUpdate}
				/>
			)}
		</tr>
	);
};
export default CardItem;
